import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useStudentUpdateProfileMutation, useShowStudentQuery } from "../../../Services/api";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from "../../../__Layout/Header";
import { useSelector } from 'react-redux';
import Loader from '../../../utils/Loader';

export default function Profile() {
  const [studentId, setStudentId] = useState("")
  const [name, setName] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const { userDetail } = useSelector((state) => state.auth)
  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("first name fields is required"),
    last_name: Yup.string().required("last name fields is required"),
    mobile_number: Yup.string().required("mobile number fields is required"),
    email: Yup.string().required("email fields is required"),
  });
  useEffect(() => {
    if (userDetail) {
      if(userDetail['user'][0]['student_id']){
        setStudentId(userDetail['user'][0]['student_id'])
      }
      else{
        setStudentId(userDetail['user'][0]['admin_id'])
      }
      
      setName(userDetail['user'][0]['first_name'])
      setLastName(userDetail['user'][0]['last_name'])
      setPhoneNumber(userDetail['user'][0]['phone_number'])
      setEmail(userDetail['user'][0]['email'])
    }
  }, [userDetail])
  
  const {
    data: showStudent,
    isLoading: isGetLoading,
  } = useShowStudentQuery({ params: studentId });
  const studentData = showStudent?.data[0];

  const notify = () => '';
  var defaultValues = {
    first_name: studentData?.first_name,
    last_name: studentData?.last_name,
    mobile_number: studentData?.mobile_number,
    email: studentData?.email,
  };

  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const [StudentUpdateProfile, isLoading] = useStudentUpdateProfileMutation();
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = methods;

  useEffect(() => {
    reset(defaultValues)
  }, [studentData])

  const onSubmitProfile = (values) => {

    StudentUpdateProfile({ data: values })
      .unwrap()
      .then((payload) => {
        if (payload.status) {
          const response = {
            user: payload.data,
          };
          toast.success(payload.message)
        } else {
          toast.error(payload.message)
        }
      })
      .catch((error) => {

        toast.error(error.error)
      });
    notify();

  };
  if (isGetLoading) return <Loader></Loader>
  return (
    <>
      <Header></Header>
      <main id="main" className="main">
        <section className="section">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Update Profile</h5>
              <form onSubmit={handleSubmit(onSubmitProfile)}>

                <div className="row mb-3">
                  <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">first name</label>
                  <div className="col-sm-10">
                    <input type="name" {...register("first_name")} className="form-control" />
                    <span className="text-danger">{errors.first_name?.message}</span>
                  </div>
                </div>
                <div className="row mb-3">
                  <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">last name</label>
                  <div className="col-sm-10">
                    <input type="name" {...register("last_name")} className="form-control" />
                    <span className="text-danger">{errors.last_name?.message}</span>
                  </div>
                </div>
                <div className="row mb-3">
                  <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">mobile number</label>
                  <div className="col-sm-10">
                    <input type="number" {...register("mobile_number")} className="form-control" readOnly />
                    <span className="text-danger">{errors.mobile_number?.message}</span>
                  </div>
                </div>
                <div className="row mb-3">
                  <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">email</label>
                  <div className="col-sm-10">
                    <input type="email" {...register("email")} className="form-control" readOnly />
                    <span className="text-danger">{errors.email?.message}</span>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-2 col-form-label"></label>
                  <div className="col-sm-10">
                    {isLoading.status !== 'pending' ?

                      <button type="submit" className="btn btn-warning w-100" >Update Profile</button>
                      :
                      <button className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                    }
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}